import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: localStorage.getItem("isLoggedIn") === "Y" ? true : false,
  clientList: "",
  client: "",
  group: "",
  sector: "",
  country: "",
  podcastList: "",
  thubLists: "",
  singleThub: "",
  thubList: "",
  thub: "",
  podcastChannels: "",
  clientChannels:"",
};

const superAdminSlice = createSlice({
  name: "superAdmin",
  initialState: initialState,
  reducers: {
    login(state, payload) {
      // console.log(payload.payload.response);
      localStorage.setItem("isLoggedIn", "Y");
      localStorage.setItem("tokenSuper", payload.payload.response.access_token);
      state.isLoggedIn = true;
    },
    getClientList(state, payload) {
      state.clientList = payload.payload.response;
    },
    getGroupList(state, payload) {
      state.group = payload.payload.response;
    },
    getSectorList(state, payload) {
      state.sector = payload.payload.response;
    },
    getCountryList(state, payload) {
      state.country = payload.payload.response;
    },
    addClient(state, payload) {
      state.client = payload.payload.response;
    },
    getPodcastList(state, payload) {
      state.podcastList = payload.payload.response;
    },
    getThubList(state, payload) {
      // console.log(payload.payload.response);
      state.thubLists = payload.payload.response;
    },
    getSingleThub(state, payload) {
      // console.log(payload.payload.response);
      state.singleThub = payload.payload.response;
    },
    setThub(state, payload) {
      // console.log(payload.payload.response);
      state.thub = payload.payload.response;
    },
    deleteThub(state, payload) {
      // console.log(payload.payload.response);
      state.thubList = payload.payload.response;
    },
    getPodcastChannels(state, payload) {
      state.podcastChannels = payload.payload.response;
    },
    getClientChannels(state, payload) {
      state.clientChannels = payload.payload.response;
    },
  },
});

export default superAdminSlice.reducer;
export const superAdminActions = superAdminSlice.actions;
